export default {
  de: {
    add: 'Kategorie hinzufügen',
    categories: 'Kategorien',
    types: 'Funktionen',
    name: 'Name',
  },
};
